import { useState, useEffect, useRef } from 'react';
import {
  Box,
  TextField,
  // FormControlLabel,
  // Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  // InputLabel,
  FormHelperText,
  Button,
} from '@material-ui/core';
import { useIntl, history } from 'umi';
import { useDispatch, useLocation, useSelector } from 'dva';
// import ModalML from '@/components/ModalML';
import { useTheme } from '@material-ui/styles';
// import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
// import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import SvgIcon from '@/components/SvgIconML/SvgIconML';
// import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { getToken } from '@/utils/token';
import webStorage from '@/utils/storageManager';
import { cryptoEncrypt } from '@/utils/aes';
import { useForm, Controller } from 'react-hook-form';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IndexStyled from './indexStyled';
import LoadingML from '@/components/LoadingML/';
// import ModalStyled from './modalStyled';
// import AccountCircle from '@material-ui/icons/AccountCircle';
// import { BRAND } from '@/constants.js';

// import router from 'umi/router';
const LoginML = () => {
  //国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const theme = useTheme();
  //关于登陆出现loading
  const loadingEffect = useSelector((state) => state.loading);
  const loginLoading = loadingEffect.effects['login/fetchLogin'];
  // const [form] = Form.useForm();
  // const intl = useIntl();
  // const { formatMessage } = intl;
  // const [visible, setVisible] = useState(false);
  const { handleSubmit, control, errors } = useForm({});
  //是否扫码登录
  const [isQrLogin, setIsQrLogin] = useState(false);
  //获取code
  const location = useLocation();
  const { query } = location;
  const { code, appid } = query;
  const saveRef = useRef();

  useEffect(() => {
    if (code && isQrLogin) {
      const submitData = {
        code,
        appid,
        isQrLogin,
        agentid: process.env.AGENT_ID,
      };
      onFinish(submitData);
    }
  }, [code, isQrLogin]);

  // const layout = {
  //   labelCol: { span: 6 },
  //   wrapperCol: { span: 16 },
  // };
  const onFinish = (submitData) => {
    const AUTH_USERNAME = 'admin-loyalty';
    const AUTH_PASSWORD = 'admin123';
    const { username, password } = submitData;
    const crypedAuthPassword = cryptoEncrypt(AUTH_PASSWORD);
    const crypedUserPassword = cryptoEncrypt(password);
    const authCode = `Basic ${btoa(`${AUTH_USERNAME}:${crypedAuthPassword}`)}`;
    webStorage.set('AUTHORIZATION', authCode);
    const payload = isQrLogin
      ? { ...submitData }
      : {
          username,
          password: crypedUserPassword,
        };
    dispatch({
      type: 'login/fetchLogin',
      payload,
      callback: ({ loginRes, userRes, dictRes }) => {
        if (loginRes && userRes && dictRes) {
          window.NE_DAWN.trigger(saveRef.current, {
            event: '_ec', // 事件名
            params: {}, // 事件公参
          });
          webStorage.set('TENANT_ID', loginRes?.tenant_id);
          webStorage.set('BRAND_APP', loginRes?.brand_app);
          const { data: user } = userRes;
          let type = [];
          let result = {};
          const { data: dict } = dictRes;
          dict &&
            dict.forEach((item) => {
              if (type.indexOf(item.dictGroup) === -1) {
                type.push(item.dictGroup);
              }
            });
          type &&
            type.forEach((item) => {
              result[item] = [];
              dict.forEach((item2) => {
                if (item === item2.dictGroup) {
                  result[item].push(item2);
                }
              });
            });

          // webStorage.set('DICTALL', res);
          webStorage.set('DICTOBJ', result);
          if (getToken()) {
            const arr = Object.keys(loginRes?.brand_app);
            if (arr.length < 2) {
              history.push({
                pathname: '/',
              });
              // 设置初始化默认品牌
              const allBrands = result.brand;
              // 用户品牌信息只有品牌ID，这里要从字典里映射品牌Code
              const defaultBrand = allBrands?.filter(
                // 设置默认选中第一个品牌
                (item) => Number(item.dictName) === Number(user.brands[0]),
              );
              // dictName 是 10001 品牌ID， dictCode 是 hxb 品牌code
              if (defaultBrand) {
                webStorage.set('BRAND_ID', defaultBrand[0]?.dictName);
                webStorage.set('BRAND_CODE', defaultBrand[0]?.dictCode);
              }
              // webStorage.set('BRAND_ID', arr[0]);
              // webStorage.set('BRAND_CODE', BRAND[arr[0]]);
            } else {
              history.push({
                pathname: '/',
                // query: {
                //   ...values,
                // },
              });
            }
          }
        }
      },
    });
  };

  //登录进来拿取二维码
  useEffect(() => {
    if (isQrLogin && !code) {
      // const script = document.createElement('script');
      // script.type = 'text/javaScript';
      // script.async = false;
      // script.src =
      //   'https://wwcdn.weixin.qq.com/node/wework/wwopen/js/wwLogin-1.2.4.js';
      // document.head.appendChild(script);
      // eslint-disable-next-line new-cap
      const wwLogin = new window.WwLogin({
        id: 'wx_reg',
        appid: process.env.APP_ID,
        agentid: process.env.AGENT_ID,
        redirect_uri: `${process.env.QW_WEB_URL}/login`, //回调地址，注意回调地址需要进行urlencode
        href: `${process.env.CDN_URL}/qrStyle.css`,
      });
      console.log(wwLogin, 'wwLogin');
    }
  }, [isQrLogin, code]);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  //扫码以后 改掉状态
  useEffect(() => {
    if (code) {
      setIsQrLogin(true);
    }
  }, [code]);

  // const showForgetPass = () => {
  //   setVisible(true);
  // };
  const [values, setValues] = React.useState({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
  });
  // const handleOk = () => {
  //   setVisible(false);
  // };
  // const handleCancel = () => {
  //   setVisible(false);
  // };
  // const onFinishForget = () => {
  //   setVisible(false);
  // };
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <>
      <IndexStyled theme={theme} isQrLogin={isQrLogin}>
        <Box className="position">
          <Box className="card-wrapper">
            <Box className="data-lake">
              <img alt="" src={require('../../assets/img/datalake2.0.png')} />
            </Box>
            <Box className="card">
              <LoadingML loading={loginLoading}>
                <Box className="toolTip">
                  {formatMessage({ id: 'login.n02.lbl01' })}
                  {/* {!isQrLogin && (
                    <img alt="" src={require('../../assets/img/toolTip.png')} />
                  )} */}
                </Box>
                <Box className="qr">
                  {isQrLogin ? (
                    <SvgIcon
                      name="computer"
                      size={64}
                      onClick={() => setIsQrLogin(false)}
                    />
                  ) : (
                    <SvgIcon
                      name="qr"
                      size={64}
                      color="blue"
                      onClick={() => setIsQrLogin(true)}
                    />
                  )}
                </Box>
                <form onSubmit={handleSubmit(onFinish, onFinishFailed)}>
                  <Box className="login_box">
                    {isQrLogin ? (
                      <Box className="qr-container">
                        <Box className="qr-title" mb={2}>
                          {formatMessage({ id: 'login.n02.lbl02' })}
                        </Box>

                        <div className="qr-wrapper" id="wx_reg"></div>

                        {/* <Box className="qr-mention" mt={6}>
                        <SvgIcon name="qrText" />
                        <span>打开企业微信，扫码登录</span>
                      </Box> */}
                      </Box>
                    ) : (
                      <Box className="right">
                        <Box className="title" mb={4}>
                          {formatMessage({ id: 'login.n01.lbl01' })}
                        </Box>
                        <Box>
                          <Controller
                            as={
                              <TextField
                                id="input-with-icon-textfield"
                                className="username"
                                autoComplete="off"
                                placeholder={formatMessage({
                                  id: 'login.n01.placeholder03',
                                })}
                                variant="standard"
                                error={Boolean(errors.username)}
                                helperText={
                                  Boolean(errors.username) &&
                                  formatMessage({ id: 'login.n01.msg07' })
                                }
                              />
                            }
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <AccountCircleRoundedIcon
                                    color="primary"
                                    sx={{ width: '24px', height: '24px' }}
                                  />
                                  {/* <SvgIcon name="denglu" size={24} color="#1565C0" /> */}
                                  {/* <AccountCircleOutlinedIcon /> */}
                                </InputAdornment>
                              ),
                            }}
                            name="username"
                            label={formatMessage({ id: 'login.n01.lbl02' })}
                            control={control}
                            rules={{ required: true }}
                            defaultValue={''}
                          />
                        </Box>
                        <Box mt={4}>
                          <FormControl
                            variant="standard"
                            className="pwd"
                            error={Boolean(errors.password)}
                          >
                            <Controller
                              as={
                                <TextField
                                  name="password"
                                  placeholder={formatMessage({
                                    id: 'login.n01.placeholder03',
                                  })}
                                  label={formatMessage({
                                    id: 'login.n01.lbl04',
                                  })}
                                  variant="standard"
                                  type={
                                    values.showPassword ? 'text' : 'password'
                                  }
                                  value={values.password || ''}
                                  autoComplete="off"
                                  onChange={handleChange('password')}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SvgIcon
                                          name="secret"
                                          size={24}
                                          color="blue"
                                        />
                                        {/* <LockOpenOutlinedIcon /> */}
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={handleClickShowPassword}
                                          onMouseDown={handleMouseDownPassword}
                                          edge="end"
                                        >
                                          {values.showPassword ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  error={Boolean(errors.password)}
                                  helperText={
                                    Boolean(errors.password) ??
                                    formatMessage({ id: 'login.n01.msg08' })
                                  }
                                />
                              }
                              name="password"
                              control={control}
                              rules={{ required: true }}
                              defaultValue={''}
                            />
                          </FormControl>
                          <FormHelperText error={Boolean(errors.password)}>
                            {Boolean(errors.password) &&
                              formatMessage({ id: 'login.n01.msg08' })}
                          </FormHelperText>
                        </Box>
                        {/* <Box mt={1} className="remember-password">
                    <FormControlLabel
                      value="end"
                      control={<Checkbox color="primary" />}
                      label="记住密码"
                      labelPlacement="end"
                    />
                    <span
                      className="forget"
                      onClick={() => {
                        setVisible(true);
                      }}
                    >
                      忘记密码
                    </span>
                  </Box> */}
                        <Box mt={5}>
                          <Button
                            data-log={JSON.stringify({
                              oid: 'event_user_login',
                              events: ['_ev'],
                              params: {
                                initUrl:
                                  window.location.origin +
                                  window.location.pathname,
                              },
                            })}
                            ref={saveRef}
                            variant="contained"
                            type="submit"
                            sx={{ width: '100%' }}
                          >
                            {formatMessage({ id: 'login.n01.btn06' })}
                          </Button>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </form>
              </LoadingML>
            </Box>

            {/* <ModalML
        title="忘记密码"
        width="600px"
        visible={visible}
        handleOk={handleOk}
        handleCancel={handleCancel}
      >
        <form name="control-hooks" onFinish={onFinishForget}>
          <div>
            <InputML
              labelVal="姓名"
              placeVal="请输入姓名"
              name="name"
              required={[
                {
                  required: true,
                  message: '请输入姓名',
                },
              ]}
            />

            <InputML
              labelVal="密码"
              placeVal="请输入密码"
              name="pass"
              required={[
                {
                  required: true,
                  message: '请输入密码',
                },
              ]}
            />
            <InputML
              labelVal="确认"
              placeVal="请再次输入密码"
              name="passAgain"
              required={[
                {
                  required: true,
                  message: '请再次输入密码',
                },
              ]}
            />
          </div>
          <footer>
            <ButtonML
              size="large"
              value="取消"
              htmlType="submit"
              fontsize="16px"
              onClick={handleCancel}
            />
            <ButtonML
              size="large"
              value="确定"
              htmlType="submit"
              fontsize="16px"
            />
          </footer>
        </form>
      </ModalML> */}
          </Box>
        </Box>
      </IndexStyled>
      {/* <ModalML
        open={visible}
        onCancel={handleCancel}
        title={'忘记密码'}
        onConfirm={handleOk}
        onClose={() => {
          setVisible(false);
        }}
      >
        <ModalStyled theme={theme}>
          <form
            onSubmit={handleSubmit(() => {
              onFinishForget();
            })}
          >
            <Box className="box">
              <Controller
                as={TextField}
                name="name"
                control={control}
                id="basic"
                placeholder="请输入姓名"
                className="input"
                label="*姓名"
                rules={{ required: true }}
                error={Boolean(errors.name)}
                helperText={Boolean(errors.name) && '请输入姓名'}
                defaultValue=""
              />
            </Box>
            <Box mt={4} className="box">
              <Controller
                as={TextField}
                name="password"
                control={control}
                id="basic"
                className="input"
                label="*密码"
                helperText={Boolean(errors.mobile) && '请输入密码'}
                rules={{
                  required: true,
                  // validate: {
                  //   numRange: isMobile,
                  // },
                }}
                error={Boolean(errors.password)}
                placeholder="请输入密码"
                defaultValue=""
              />
            </Box>
            <Box mt={4} className="box">
              <Controller
                as={TextField}
                name="password1"
                control={control}
                id="basic"
                className="input"
                label="*密码"
                helperText={Boolean(errors.mobile) && '请输入密码'}
                rules={{
                  required: true,
                  // validate: {
                  //   numRange: isMobile,
                  // },
                }}
                error={Boolean(errors.password1)}
                placeholder="请再次输入密码"
                defaultValue=""
              />
            </Box>
            <Box className="buttonWrap">
              <Button
                onClick={() => {
                  setVisible(false);
                }}
                variant="contained"
                color="secondary"
              >
                {props.cancelText ? props.cancelText : '取 消'}
              </Button>
              <Button
                variant="contained"
                type="submit"
                className="btnSubmit button"
              >
                {props.confirmText ? props.confirmText : '保 存'}
              </Button>
            </Box>
          </form>
        </ModalStyled>
      </ModalML> */}
    </>
  );
};
export { LoginML };
